import { render } from "./PopUpObservation.vue?vue&type=template&id=ab33178e"
import script from "./PopUpObservation.vue?vue&type=script&lang=js"
export * from "./PopUpObservation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__